import React, { Component } from 'react';
import DatePicker from 'material-ui/DatePicker';
import * as Colors from '../../utils/Color';


const styles = {
    errorStyle: {
        color: Colors.error,
    },
    underlineStyle: {
        borderColor: Colors.grey
    },
    underlineFocusStyle: {
        borderColor: Colors.primary
    },
    floatingLabelStyle: {
        fontWeight: 'bold',
        color: Colors.grey50
    },
    hintLabelStyle: {
        fontWeight: 'bold',
        color: Colors.grey50
    },
    floatingLabelFocusStyle: {
        color: Colors.grey50,
        fontSize: '18px'
    },
    backgroundColor: {
        backgroundColor: Colors.grey
    }
};


class DatePickerUI extends Component {
    render() {
        const { name, onChange, label, value, disabled } = this.props;
        let values = {};
        if (value) {
            values.value = value
        }

        return (
            <DatePicker hintText={ label }
                        disabled={disabled}
                        name={name}
                        {...values}
                        onChange={ (e, date) => onChange(name, date) }
                        fullWidth={ true }
                        mode="landscape"
                        className="text-field"
                        hintStyle={ styles.hintLabelStyle }
                        underlineStyle={ styles.underlineStyle }
                        underlineFocusStyle={ styles.underlineFocusStyle }
                        floatingLabelStyle={ styles.floatingLabelStyle }
                        floatingLabelFocusStyle={ styles.floatingLabelFocusStyle }/>
        );
    }
}

export default DatePickerUI;



// WEBPACK FOOTER //
// ./src/components/UI/DatePicker-f.js